import React, { Component } from 'react';
class PageLoader extends Component {

    componentDidMount() {
        console.log(this.props.show);
    }
    render() {
        return (
            <div className="wapper-loader" style={{ display: this.props.show > 0 ? "block" : "none" }}>
                {/* <img src="https://smallenvelop.com/demo/image-loading/spinner.gif" alt="loader" /> */}
                <div className="lds-dual-ring"></div>
            </div>)
    }
}
export default PageLoader;